import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { AssetType } from "../../../shared/types/AssetType";
import { orderMappers } from "../../../screens/portfolio-info/mappers/OrderMappers";

export interface AssetTypeSelectorProps {
    value: AssetType;
    onValueChange: (newValue: AssetType) => void;
    disabled?: boolean;
}

export function AssetTypeSelector({
    value,
    onValueChange,
    disabled,
}: AssetTypeSelectorProps) {
    const onChange = (newValue: SelectChangeEvent<string>) => {
        onValueChange(orderMappers.getType(newValue.target.value));
    }
    
    return (
        <FormControl
            variant="standard"
            sx={{ width: 80 }}
            disabled={disabled}
        >
            <InputLabel id="type-label">
                Type
            </InputLabel>
            <Select
                labelId="type-label"
                id="type"
                size="small"
                value={AssetType[value]}
                onChange={onChange}
                sx={{
                    "& .MuiInputBase-input": {
                        paddingBottom: '2px',
                    },
                }}
            >
                <MenuItem
                    key="Spot"
                    value="Spot"
                >
                    Spot
                </MenuItem>
                <MenuItem
                    key="Futures"
                    value="Futures"
                >
                    Futures
                </MenuItem>
                <MenuItem
                    key="Call"
                    value="Call"
                >
                    Call
                </MenuItem>
                <MenuItem
                    key="Put"
                    value="Put"
                >
                    Put
                </MenuItem>
            </Select>
        </FormControl>
    );
}
